
import { Button, InputLabel } from '@mui/material';

export default function SortBox({ sortValue, setSortValue }) {
    return(
      <>
      <InputLabel>Order By:</InputLabel>
      {([{ text: "Color", value: "color" },
         { text: "Company Name", value: "name" },
        //  { text: "Region", value: "region" }
        ]).map(m =>
            <Button
              className="me-1"
              variant={sortValue === m.value ? "contained" : "outlined"}
              onClick={(e) => setSortValue(m.value)}
              color="Grey"
              key={`orderby-toggle-${m.value}`}
            >
              {m.text}
            </Button>
         )}
      </>
    )
  }